"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
const react_router_dom_1 = require("react-router-dom");
//
// assets
//
const blankBackground_webp_1 = __importDefault(require("../../../assets/images/blankBackground.webp"));
const HeroImage_1 = __importDefault(require("../HeroImage"));
const queryDefinitions_1 = require("../../../queryDefinitions");
const registerCopy_1 = require("../../../copy/registerCopy");
const cache_1 = require("../../../cache");
const tokenHeader_1 = require("../../../tokenHeader");
//
// components
//
const OnboardingForm_1 = __importDefault(require("../OnboardingForm"));
const GenericInput_1 = __importDefault(require("../../general/inputs/GenericInput"));
const PasswordInput_1 = __importDefault(require("../../general/inputs/PasswordInput"));
const SubdomainInput_1 = __importDefault(require("../../general/inputs/SubdomainInput"));
const FormValidation_1 = require("../../general/utility/FormValidation");
//
// styles
//
const StyledImageBackground_1 = require("../styles/StyledImageBackground");
const LocalAccount_1 = __importDefault(require("../../../LocalAccount"));
const AccountContext_1 = require("../../../contexts/AccountContext");
const Register = () => {
    const { setAccount } = (0, AccountContext_1.useAccount)();
    const history = (0, react_router_dom_1.useHistory)();
    const [storeName, setStoreName] = (0, react_1.useState)('');
    const [subdomain, setSubdomain] = (0, react_1.useState)('');
    const [name, setName] = (0, react_1.useState)('');
    const [email, setEmail] = (0, react_1.useState)('');
    const [password, setPassword] = (0, react_1.useState)('');
    const [storeNameError, setStoreNameError] = (0, react_1.useState)('');
    const [subdomainError, setSubdomainError] = (0, react_1.useState)('');
    const [nameError, setNameError] = (0, react_1.useState)('');
    const [emailError, setEmailError] = (0, react_1.useState)('');
    const [passwordError, setPasswordError] = (0, react_1.useState)('');
    const linkProps = {
        preface: registerCopy_1.registerCopy.linkPreface,
        href: registerCopy_1.registerCopy.linkHref,
        prompt: registerCopy_1.registerCopy.linkPrompt
    };
    // eslint-disable-next-line complexity
    function handleBlur(event) {
        const error = (0, FormValidation_1.validateInput)(event.target.id, event.target.value);
        if (error) {
            if (event.target.id === 'storeName') {
                setStoreNameError(error);
            }
            if (event.target.id === 'subdomain') {
                setSubdomainError(error);
            }
            if (event.target.id === 'name') {
                setNameError(error);
            }
            if (event.target.id === 'email') {
                setEmailError(error);
            }
            if (event.target.id === 'password') {
                setPasswordError(error);
            }
        }
        else {
            if (event.target.id === 'storeName') {
                setStoreNameError('');
            }
            if (event.target.id === 'subdomain') {
                setSubdomainError('');
            }
            if (event.target.id === 'name') {
                setNameError('');
            }
            if (event.target.id === 'email') {
                setEmailError('');
            }
            if (event.target.id === 'password') {
                setPasswordError('');
            }
        }
    }
    function handleInputChange(event) {
        if (event.target.id === 'storeName') {
            setStoreName(event.target.value);
        }
        if (event.target.id === 'subdomain') {
            setSubdomain(event.target.value);
        }
        if (event.target.id === 'name') {
            setName(event.target.value);
        }
        if (event.target.id === 'email') {
            setEmail(event.target.value);
        }
        if (event.target.id === 'password') {
            setPassword(event.target.value);
        }
    }
    const [signUp, { data: signupData, loading: signUpLoading, error: signupError }] = (0, client_1.useMutation)(queryDefinitions_1.REGISTER_USER);
    const [authedLazyQuery, 
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((options?... Remove this comment to see the full error message
    { data: accountData, loading: accountLoading, error: accountError }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_ACCOUNTS);
    const [login, { loading: loginLoading, error: loginError }] = (0, client_1.useMutation)(queryDefinitions_1.LOGIN_USER, {
        onCompleted({ signIn }) {
            if (signIn) {
                localStorage.setItem('token', signIn.session.token);
                (0, cache_1.isLoggedInVar)(true);
                // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
                authedLazyQuery({ variables: { first: 1 } });
            }
        }
    });
    function handleRegistration(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            yield signUp({
                variables: {
                    input: {
                        accountDomain: `${subdomain}.${process.env.ROOT_HOSTED_DOMAIN}`,
                        accountName: storeName,
                        userEmail: email,
                        userName: name,
                        userPassword: password
                    }
                }
            });
        });
    }
    // eslint-disable-next-line complexity
    function setInputError(error) {
        if (error.field === 'account_name') {
            if (error.message === 'format') {
                setStoreNameError('Please enter a valid account');
            }
            if (error.message === 'unique') {
                setStoreNameError('This account name has already been used');
            }
        }
        if (error.field === 'account_domain') {
            if (error.message === 'format') {
                setSubdomainError('Please enter a valid domain');
            }
            if (error.message === 'unique') {
                setSubdomainError('This domain has already been used');
            }
        }
        if (error.field === 'user_name') {
            if (error.message === 'format') {
                setNameError('Please enter a valid name');
            }
        }
        if (error.field === 'user_email') {
            if (error.message === 'format') {
                setEmailError('Please enter a valid email');
            }
            if (error.message === 'unique') {
                setEmailError('This email has already been used');
            }
        }
        if (error.field === 'user_password') {
            if (error.message === 'format') {
                setPasswordError('Please enter a valid password');
            }
            if (error.message === 'length') {
                setPasswordError('Passwords must be at least 8 characters');
            }
        }
    }
    (0, react_1.useEffect)(() => {
        if (signupData) {
            login({ variables: { input: { email: email, password: password } } });
        }
        if (accountData) {
            setAccount(accountData.accounts.edges[0].node);
            // LocalAccount should no longer be necessary when we start using the
            // account context, but for now there's some duplication
            LocalAccount_1.default.set(accountData.accounts.edges[0].node);
            history.push('/orders');
        }
        if (signupError) {
            signupError.graphQLErrors.map((error) => {
                setInputError(error);
            });
        }
    }, [signupData, accountData, signupError]);
    let apiError = signupError;
    if (loginError) {
        apiError = loginError;
    }
    if (accountError) {
        apiError = accountError;
    }
    let apiLoading = false;
    if (loginLoading || accountLoading || signUpLoading) {
        apiLoading = true;
    }
    return (react_1.default.createElement(StyledImageBackground_1.StyledImageBackground, { id: 'register', url: blankBackground_webp_1.default },
        react_1.default.createElement(OnboardingForm_1.default, { apiError: apiError, contactLink: linkProps, cta: registerCopy_1.registerCopy.cta, header: registerCopy_1.registerCopy.header, inputs: [
                react_1.default.createElement(GenericInput_1.default, { error: storeNameError, id: 'storeName', key: 'storeName', label: registerCopy_1.registerCopy.input1, onBlur: handleBlur, onInputChange: handleInputChange }),
                react_1.default.createElement(SubdomainInput_1.default, { error: subdomainError, id: 'subdomain', key: 'subdomain', label: registerCopy_1.registerCopy.input2, onBlur: handleBlur, onInputChange: handleInputChange }),
                react_1.default.createElement(GenericInput_1.default, { error: nameError, id: 'name', key: 'name', label: registerCopy_1.registerCopy.input3, onBlur: handleBlur, onInputChange: handleInputChange }),
                react_1.default.createElement(GenericInput_1.default, { error: emailError, id: 'email', key: 'email', label: registerCopy_1.registerCopy.input4, onBlur: handleBlur, onInputChange: handleInputChange }),
                react_1.default.createElement(PasswordInput_1.default, { error: passwordError, id: 'password', key: 'password', label: registerCopy_1.registerCopy.input5, onBlur: handleBlur, onInputChange: handleInputChange })
            ], loading: apiLoading, onFormSubmit: handleRegistration }),
        react_1.default.createElement(HeroImage_1.default, { header: registerCopy_1.registerCopy.heroHeader, subheader: registerCopy_1.registerCopy.heroSubHeader })));
};
exports.default = Register;
